import { render, staticRenderFns } from "./MessageBalloonInfoRow.vue?vue&type=template&id=4ac9ea29&scoped=true&"
import script from "./MessageBalloonInfoRow.vue?vue&type=script&lang=js&"
export * from "./MessageBalloonInfoRow.vue?vue&type=script&lang=js&"
import style0 from "./MessageBalloonInfoRow.vue?vue&type=style&index=0&id=4ac9ea29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9ea29",
  null
  
)

export default component.exports